import React from 'react';
import { Button } from './ui/button';
import { ArrowRight, CheckCircle2 } from 'lucide-react';

const CTA = ({ onCheckFlight }) => {
  return (
    <section className="bg-white" style={{ paddingTop: '80px', paddingBottom: '80px' }}>
      <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
        {/* Premium Card Container - matching Regulations style */}
        <div 
          className="relative overflow-hidden rounded-3xl shadow-xl"
          style={{
            background: 'linear-gradient(135deg, #1e40af 0%, #2563eb 50%, #3b82f6 100%)',
          }}
        >
          {/* Subtle noise texture */}
          <div 
            className="absolute inset-0 pointer-events-none opacity-[0.04]"
            style={{
              backgroundImage: `url("data:image/svg+xml,%3Csvg viewBox='0 0 400 400' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noiseFilter'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='4' /%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noiseFilter)' /%3E%3C/svg%3E")`,
              backgroundRepeat: 'repeat',
              backgroundSize: '128px 128px'
            }}
          />
          
          {/* Grid pattern overlay */}
          <div className="absolute inset-0 opacity-[0.06]">
            <div className="absolute inset-0 bg-grid-white" />
          </div>

          {/* Content with proper padding */}
          <div className="relative z-10 px-8 md:px-12 py-12 md:py-16 text-center">
            <h2 
              className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white leading-tight mx-auto"
              style={{ 
                maxWidth: '22ch',
                textWrap: 'balance',
                WebkitTextWrap: 'balance',
                marginBottom: '16px'
              }}
            >
              Ready to Claim Your Compensation?
            </h2>
            <p 
              className="text-lg sm:text-xl text-blue-100 mx-auto leading-relaxed"
              style={{ 
                marginBottom: '24px'
              }}
            >
              Check your flight in just 2 minutes. No upfront costs,<br className="hidden md:block" />
              <span className="md:hidden"> </span>only 25% + VAT if you win.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center items-center" style={{ marginBottom: '32px' }}>
              <Button 
                size="lg"
                onClick={onCheckFlight}
                className="bg-white text-blue-600 hover:bg-blue-50 px-8 py-6 text-base font-bold rounded-xl shadow-2xl hover:shadow-3xl transition-all duration-300 transform hover:scale-105"
              >
                Check My Flight Now
                <ArrowRight className="ml-2 w-5 h-5" />
              </Button>
            </div>

            <div className="flex flex-wrap items-center justify-center gap-10 lg:gap-12 text-white text-sm sm:text-base">
              <div className="flex items-center gap-2">
                <CheckCircle2 className="w-5 h-5 text-green-300" />
                <span className="whitespace-nowrap">No win, no fee</span>
              </div>
              <div className="flex items-center gap-2">
                <CheckCircle2 className="w-5 h-5 text-green-300" />
                <span className="whitespace-nowrap">95% success rate</span>
              </div>
              <div className="flex items-center gap-2">
                <CheckCircle2 className="w-5 h-5 text-green-300" />
                <span className="whitespace-nowrap">Average €450 per claim</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTA;
